import React from 'react';
import {
  NetWorthTableHeader,
  StyledNetWorthTable,
  NetWorthTableLabelCell,
  NetWorthTableValueCell,
  NetWorthTableRow,
  NetWorthTableGroupHeader,
} from './NetWorthTableStyles';
import { formatNumberLegacy } from '../../../CommonUtils/formatNumberLegacy';
import { NetWorthTableEmpty } from './NetWorthTableEmpty';
import { NetWorthTableData } from '../../MoneyGuideProTypes';

interface Props {
  data: NetWorthTableData | null;
}

export const NetWorthTable: React.FC<Props> = ({ data }) => {
  if (!data) {
    return <NetWorthTableEmpty />;
  }

  return (
    <StyledNetWorthTable>
      <NetWorthTableHeader>
        <NetWorthTableLabelCell style={{ fontWeight: 600 }}>Description</NetWorthTableLabelCell>
        <NetWorthTableValueCell style={{ fontWeight: 600 }}>Total</NetWorthTableValueCell>
      </NetWorthTableHeader>
      {data.groups.map(({ title, color, rows }) => (
        <React.Fragment key={title}>
          <NetWorthTableGroupHeader color={color}>{title}</NetWorthTableGroupHeader>
          {rows.map(({ value, label }) => (
            <NetWorthTableRow key={label}>
              <NetWorthTableLabelCell>{label}</NetWorthTableLabelCell>
              <NetWorthTableValueCell>
                {formatNumberLegacy(value, { type: 'currency' })}
              </NetWorthTableValueCell>
            </NetWorthTableRow>
          ))}
          <NetWorthTableRow>
            <NetWorthTableLabelCell style={{ fontWeight: 600 }}>
              Total {title}
            </NetWorthTableLabelCell>
            <NetWorthTableValueCell style={{ fontWeight: 600 }}>
              {formatNumberLegacy(
                rows.reduce((acc, { value }) => acc + value, 0),
                { type: 'currency' },
              )}
            </NetWorthTableValueCell>
          </NetWorthTableRow>
        </React.Fragment>
      ))}
      <NetWorthTableGroupHeader color={data.netWorth.color}>
        <NetWorthTableRow>
          <NetWorthTableLabelCell style={{ fontWeight: 700, padding: 0 }}>
            Net Worth
          </NetWorthTableLabelCell>
          <NetWorthTableValueCell style={{ fontWeight: 700, padding: 0 }}>
            {formatNumberLegacy(data.netWorth.value, { type: 'currency' })}
          </NetWorthTableValueCell>
        </NetWorthTableRow>
      </NetWorthTableGroupHeader>
    </StyledNetWorthTable>
  );
};
